export default __webpack_public_path__ + "static/media/IMG_0421.114305b1.jpg";